import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type VerifyDomainPayload = {
  name: string;
  dealer_id: number;
};

type VerifyDomainResponse = {
  message: string;
};

export const useVerifyDomainInfoMutation = () =>
  useTypedMutation<VerifyDomainPayload, VerifyDomainResponse>({
    mutationFn: async (payload: VerifyDomainPayload) => (await ApiInstance.post("/domains/verify", payload, ENV.dealerBaseURL)).data,
    onSuccess: (payload, response) => {
      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1) {
        const dealer = dealersList.dealers[dealerIdx];
        if (dealer.domain)
          typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
            ...dealersList,
            dealers: dealersList.dealers.with(dealerIdx, { ...dealer, domain: { ...dealer.domain, state: response.message } })
          });
      }

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (!selectedDealer) return;

      setSelectedDealer({
        ...selectedDealer,
        ...(selectedDealer.domain && { domain: { ...selectedDealer.domain, state: response.message } })
      });
    }
  });
